<template>
  <div class="form-element" :class="{ '-login': isLoginPage }">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <input
      class="form-element__input"
      :class="classObject"
      type="tel"
      name="Cep Telefonu Numarası"
      :placeholder="placeholder"
      autocomplete="off"
      @keyup="changed"
      v-model.trim="val"
     
      v-mask="'# ### ### ## ##'"
    />
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message"
    >
      {{ message }}
    </div>
    <div
      class="form-element__message"
      :class="{ '-error': isError }"
      v-if="message2"
      style="color:red"
    >
      {{ message2 }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    isQuarter: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    message2: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "Cep Numarası",
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
   
  },
  data() {
    return {
      val: null,
      isLoginPage: this.$route.meta.layout == "login",
    };
  },
 
  computed: {
    classObject: function() {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-half": this.isHalf,
        "-quarter": this.isQuarter,
        "-border": this.isBorder,
      };

      return list;
    },
  },
  created() {
    this.makeVal();
  },
  methods: {
    makeVal: function() {
      let val = this.value;
      if (!!val && val.charAt(0) != 0) val = `0${val}`;
      this.val = val;
    },
    changed: function(e) {
      let val = e.target.value;
      if (val != "") {
        if (val.charAt(0) != "0" || val.charAt(2) != "5")
          return (this.val = `0 5`);

        if (val.length == 15)
          return this.$emit("input", val.replace(/ /g, "").substring(1));

        return this.$emit("input", null);
      } else {
        return this.$emit("input", null);
      }
    },
  },
};
</script>
